export default function MarcoLegalYReforma2025() {
  return <section data-section-id="259552" id="marco-legal-y-reforma-2025" className="bg-background py-16 md:py-24 text-foreground">
      <div className="page-container">
        <div className="mx-auto max-w-3xl">
          <h2 className="font-default mb-10 text-center text-3xl font-bold text-foreground md:text-4xl">
            Marco{" "}
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              Legal y Reforma 2025
            </span>
          </h2>

          <div className="space-y-6 text-base leading-relaxed text-muted-foreground md:text-lg font-default">
            <p>
              La prevención de lavado de dinero en México se rige principalmente por la LFPIORPI. Para los sujetos obligados del{" "}
              <span className="font-mono text-primary font-medium">Artículo 17</span>, el cumplimiento no es opcional, sino una salvaguarda operativa esencial frente a la fiscalización de la Unidad de Inteligencia Financiera.
            </p>

            <div className="p-6 bg-card border-l-4 border-primary rounded-md shadow-md">
              <p className="font-mono text-sm text-foreground leading-relaxed">
                <span className="font-bold block mb-2 text-primary">REFORMA ART. 62 (2025):</span>
                "Las sanciones por omisión en la presentación de avisos o integración de expedientes de identificación podrán incrementarse hasta en un 40% para entidades que no cuenten con sistemas automatizados de monitoreo."
              </p>
            </div>

            <p>
              Notalia nace para resolver la complejidad técnica de esta normativa. Entendemos que el{" "}
              <span className="font-medium text-primary">cumplimiento normativo</span>{" "}
              suele percibirse como una carga administrativa pesada que distrae del núcleo del negocio, especialmente ante las nuevas exigencias de la reforma 2025.
            </p>

            <p>
              Nuestra misión es{" "}
              <span className="font-medium text-primary">digitalizar la debida diligencia</span>{" "}
              mediante herramientas de KYC y screening que operan bajo los más altos estándares de seguridad, permitiendo que tu empresa cumpla con el Art. 17 sin complicaciones técnicas ni riesgos legales.
            </p>

            <p>
              Hoy, Notalia es el aliado estratégico de notarías, inmobiliarias y diversos sectores en México. No somos solo un software; somos tu{" "}
              <span className="font-mono text-accent">escudo de cumplimiento</span>{" "}
              diseñado para que tu operación sea auditable, transparente y segura en todo momento.
            </p>
          </div>
        </div>
      </div>
    </section>;
}